import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationMotorEfficiency extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationMotorEfficiencyHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_motor_efficiency';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationMotorEfficiency> = {
        fromFirestore: (snapshot) => {
            return PumpingStationMotorEfficiencyHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationMotorEfficiency) : firebase.firestore.DocumentData => {
            return PumpingStationMotorEfficiencyHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationMotorEfficiency {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationMotorEfficiency,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationMotorEfficiency) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationMotorEfficiencyHelper.COLLECTION_NAME).withConverter(PumpingStationMotorEfficiencyHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationMotorEfficiencyHelper.COLLECTION_NAME).withConverter(PumpingStationMotorEfficiencyHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationMotorEfficiency) {
        return PumpingStationMotorEfficiencyHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationMotorEfficiencyHelper.COLLECTION_NAME)
            .withConverter(PumpingStationMotorEfficiencyHelper.converter);
    }
}